import React from "react";
import { message, Form } from "antd";
import styled from "styled-components";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

import Button from "components/buttons/Button";
import NumberInput from "components/inputs/NumberInput";
import Select from "components/inputs/Select";
import DateSelect from "components/inputs/DateSelect";
import Fetch from "components/Fetch";
import Loading from "components/App/Loading";
import colors from "constants/palette";
import { toEnglishDigits } from "common";

let splittedDate = new Date().toLocaleDateString("fa-IR").split("/");
let currentYear = toEnglishDigits(splittedDate[0]);
let currentMonth = toEnglishDigits(splittedDate[1]);

export default function Targets({ setData, oldData, handleCancel }) {
  const [form] = Form.useForm();
  console.log(oldData?.list && JSON.parse(oldData.list));
  const [reload, setReload] = React.useState(false);
  const [total, setTotal] = React.useState(0);
  const [list, setList] = React.useState(
    oldData?.list?.length
      ? JSON.parse(oldData.list)
      : [
          {
            brand: "",
            value: "",
          },
        ]
  );
  const [info, setInfo] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    Fetch.get("/brand", (res) => {
      if (res) {
        setInfo(res.brands);
      } else {
        message.error("خطایی رخ داده است");
      }
    });
  }, []);
  React.useEffect(() => {
    setTotal(
      list.map((item) => item.value).reduce((a, b) => Number(a) + Number(b), 0)
    );
  }, [reload, list]);

  const onSubmit = (data) => {
    if (
      list.filter((item) => item.value.length === 0 || item.brand.length === 0)
        .length > 0
    ) {
      message.error("لطفا همه فیلد ها را پر کنید یا فیلد های خالی را حذف کنید");
      return false;
    }
    var submitData = {
      date: `${data.year}-${data.month}`,
      value: total,
      visitors: JSON.stringify({}),
      list: JSON.stringify(list),
      data: JSON.stringify({}),
    };

    setLoading(true);

    if (!oldData) {
      // new :::::::::::::
      Fetch.post("/targets", submitData, (res) => {
        console.log("new targets response", res);
        if (res?.id) {
          message.success("با موفقیت اضافه شد");
          cleanForm();
          setData((e) => [...e, res]);
          setList([
            {
              brand: "",
              value: "",
            },
          ]);
          setReload((e) => !e);
        } else {
          if (res?.errors.date) {
            message.error(res?.errors.date[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    } else {
      // update :::::::::

      if (oldData.date === submitData.date) {
        delete submitData.date;
      }

      Fetch.put(`/targets/${oldData.id}`, submitData, (res) => {
        console.log("new targets response/UPDATE", res);
        if (res?.id) {
          message.success("با موفقیت آپدیت شد");

          setData((e) => {
            var newData = e;
            newData[e.findIndex((item) => item.id === res.id)] = res;
            console.log("newData", newData);
            return newData;
          });

          handleCancel();
          cleanForm();
        } else {
          if (res?.errors?.date) {
            message.error(res?.errors.date[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    }
    setLoading(false);
  };

  function cleanForm() {
    form.resetFields();
  }
  function handleAddRow() {
    if (info.length === list.length) {
      message.error("همه برند ها اضافه شده اند");
      return false;
    }

    if (list[list.length - 1].brand && list[list.length - 1].value) {
      setList((e) => [
        ...e,
        {
          brand: "",
          value: "",
        },
      ]);
      setReload((e) => !e);
    } else {
      message.error("لطفا فیلد های قبلی را به درستی پر کنید");
    }
  }

  const HandleDelete = (key) => {
    setList((e) => {
      var newList = e;
      newList.splice(key, 1);
      return newList;
    });
    setReload((e) => !e);
  };

  if (oldData) {
    form.setFieldsValue(oldData);
  }
  console.log(list);
  if (!info) {
    return <Loading />;
  }
  return (
    <Form
      form={form}
      layout="vertical"
      style={{ direction: "rtl" }}
      name={oldData ? "update" : "new"}
      onFinish={onSubmit}
      initialValues={{
        year: oldData ? Number(oldData.date.split("-")[0]) : currentYear,
        month: oldData ? Number(oldData.date.split("-")[1]) : currentMonth,
      }}
    >
      <Label>تاریخ :</Label>

      <DateSelect currentYear={currentYear} />
      <Row>
        <div>
          <Label>برند :</Label>
        </div>
        <div>
          <Label>مبلغ :</Label>
        </div>
        <div style={{ width: 32 }}></div>
      </Row>
      {list.map((item, key) => (
        <Row key={key}>
          <div>
            <Select
              style={{ width: "100%" }}
              no_default="true"
              borderradius="0"
              list={info}
              showSearch
              placeholder="جستجو"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
              onChange={(newValue) => {
                if (list.filter((item) => item.brand === newValue).length > 0) {
                  message.error("این برند اضافه شده است");
                  HandleDelete(key);
                  return false;
                } else {
                  setList((e) => {
                    var oldList = e;
                    oldList[key] = {
                      brand: newValue,
                      value: e[key].value,
                    };

                    return oldList;
                  });
                  setReload((e) => !e);
                }
              }}
              value={list[key].brand}
            />
          </div>
          <div>
            <NumberInput
              size="large"
              style={{ width: "100%" }}
              onChange={(newValue) => {
                setList((e) => {
                  let oldList = e;
                  oldList[key] = {
                    brand: e[key].brand,
                    value: newValue,
                  };

                  return oldList;
                });
                setReload((e) => !e);
              }}
              value={list[key].value}
            />
          </div>
          <DeleteBtn color={colors.red} onClick={() => HandleDelete(key)}>
            <DeleteOutlined />
          </DeleteBtn>
        </Row>
      ))}

      <Button
        style={{ marginTop: 16 }}
        color={colors.blue}
        onClick={handleAddRow}
      >
        <PlusOutlined style={{ marginLeft: 8 }} />
        اضافه کردن سطر
      </Button>

      <Total>
        جمع کل :<span>{total}</span>
      </Total>
      <Button
        loading={loading}
        htmlType="submit"
        style={{ width: "100%", marginTop: 42 }}
      >
        {oldData ? (
          "اصلاح"
        ) : (
          <span>
            <PlusOutlined style={{ marginLeft: 8 }} />
            اضافه کردن تارگت
          </span>
        )}
      </Button>
    </Form>
  );
}

const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  & > div {
    width: 42%;
  }
`;
const DeleteBtn = styled(Button)`
  padding: 6px;
`;
const Total = styled.div`
  margin-top: 12px;
  & span {
    font-weight: bold;
  }
`;
